var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "skokka-gallery" },
    [
      _vm.images.length > 1
        ? _c("skokka-gallery-modal", { attrs: { items: _vm.images } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "skokka-carousel",
        {
          attrs: {
            infinite: _vm.infiniteScroll,
            auto: _vm.autoScroll,
            "track-class-name": "masonry",
          },
        },
        _vm._l(_vm.images, function (src, i) {
          return _c(
            "skokka-carousel-slide",
            { key: i + "-slide", staticClass: "gallery-item" },
            [
              _vm.isDesktop
                ? _c("a", { attrs: { href: src } }, [
                    _c("img", { attrs: { src: src } }),
                  ])
                : _c("img", { attrs: { src: src } }),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }